import { replace } from 'redux-first-history'

export default function replaceRouterAction () {
  return replace(...arguments)
}
